import { defineComponent as _defineComponent } from 'vue'
import { useDonationFormsStore } from '../../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'Gateways',
  props: ["gateways", "show_recurring", "strings"],
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const props = __props;

const setValue = (key, val) => {
	store[key] = val;
};
const getBack = () => {
};



const __returned__ = { store, props, setValue, getBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})